/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Button, Modal, TableProps } from 'antd';
import TableComponent from '../table';
import { formatDate, formatNumber } from '@/utils/dataUtils';
import { ICollectorItem } from '@/interfaces/collector';

interface IProps {
  items: ICollectorItem[];
  isBill: boolean;
  open: boolean;
  handleCancel: () => void;
}

const CollectItemModal = ({ open, handleCancel, items, isBill }: IProps) => {
  const columns: TableProps<ICollectorItem>['columns'] = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      width: 40,
      align: 'center',
      className: 'text-center',
      render: (_, rec, i) => <div>{i + 1}</div>,
    },
    {
      title: 'AWB',
      dataIndex: 'code',
      key: 'code',
      className: 'font-bold',
      width: 120,
      align: 'center',
    },
    {
      title: 'รหัสลูกค้า',
      dataIndex: 'customerCode',
      key: 'customerCode',
      className: 'font-bold',
      width: 120,
      align: 'center',
    },
    {
      title: 'ชื่อลูกค้า',
      dataIndex: 'customerName',
      key: 'customerName',
      className: 'font-bold',
    },
    {
      title: 'วันที่วางบิล',
      dataIndex: 'billingDate',
      key: 'billingDate',
      className: 'font-bold',
      width: 120,
      align: 'center',
      render: _ => formatDate(_),
    },
    {
      title: isBill ? 'เลขที่บิล' : 'เลขที่ CHEQUE',
      dataIndex: 'billingNo',
      key: 'billingNo',
      className: 'font-bold',
      width: 120,
      align: 'center',
    },
    {
      title: 'เลขที่ Invoice',
      dataIndex: 'ivNo',
      key: 'ivNo',
      className: 'font-bold',
      width: 120,
      align: 'center',
    },
    {
      title: isBill ? 'PAY DATE' : 'CHEQUE DATE',
      dataIndex: 'paidDate',
      key: 'paidDate',
      className: 'font-bold',
      width: 120,
      align: 'center',
      render: _ => formatDate(_),
    },
    {
      title: isBill ? 'ยอดวางบิล' : 'ยอดรับ CHEQUE',
      dataIndex: 'billingAmount',
      key: 'billingAmount',
      className: 'font-bold',
      width: 120,
      align: 'right',
      render: _ => formatNumber(_, 2),
    },
    {
      title: 'ยอด Invoice',
      dataIndex: 'paidAmount',
      key: 'paidAmount',
      className: 'font-bold',
      width: 120,
      align: 'right',
      render: _ => formatNumber(_, 2),
    },
  ];

  return (
    <Modal
      title="Collector Item"
      open={open}
      width={'1200px'}
      onCancel={handleCancel}
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ปิด
        </Button>,
      ]}
    >
      <div className="flex flex-col gap-3 w-full">
        <TableComponent<ICollectorItem>
          columns={columns}
          criteria={{}}
          data={{ data: items, totalRecords: items?.length || 0 }}
          onTableChange={() => console.log()}
          showPagination={false}
          scrollLength={1400}
          loading={false}
        />
      </div>
    </Modal>
  );
};

export default CollectItemModal;
